import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';

interface SuccessMessageProps {
    className?: string;
    iconClassName?: string;
    message: string;
}

const SuccessMessage = (props: SuccessMessageProps) => {
    const { className, iconClassName, message } = props;

    return (
        <span className={`success-message ${className || ''}`} data-testid="success-message">
            <FontAwesomeIcon className={`success-icon ${iconClassName}`} icon={faCheckCircle} />
            <span id={'success-message'}>{message}</span>
        </span>
    );
};

export default SuccessMessage;
